export const disableDefaultScroll = function(){
    // $('html').css({overflow: 'hidden'})
    if (window.addEventListener) // older FF
      window.addEventListener('DOMMouseScroll', preventDefault, false);

    document.body.addEventListener('touchmove', preventDefault, { passive: false });
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    window.ontouchmove = document.ontouchmove  = preventDefault; // mobile  
    // document.onkeydown  = preventDefaultForScrollKeys;
  }
  export const enableDefaultScroll = function() {
    // $('html').css({overflow: 'visible'})
    if (window.removeEventListener)
      window.removeEventListener('DOMMouseScroll', preventDefault, false);
    
    document.body.removeEventListener('touchmove', preventDefault, { passive: false });
    window.onwheel = null; 
    window.onmousewheel = document.onmousewheel = null; 
    window.ontouchmove = document.ontouchmove = null;  
    // document.onkeydown = null;  
  }


  export const gsapCustomEase = function() {
    return CustomEase.create("custom", "M0,0 C0.29,0 0.294,0.052 0.35,0.148 0.404,0.241 0.404,0.378 0.436,0.518 0.456,0.608 0.505,0.756 0.586,0.864 0.666,0.971 0.704,1 1,1");
  }


  export const mobileLayout = function() {
    // console.log(window.innerWidth);
    return window.innerWidth < 667
  }


  function preventDefault(e) {
  e = e || window.event;
  if (e.preventDefault)
      e.preventDefault();
  e.returnValue = false;  
}